(function(){
  const header = document.querySelector(".header ");
  const subMenu = document.querySelector("li.has-submenu");
  let timeoutFn = null;
  
  subMenu.addEventListener("mouseenter", function(event) {
    clearTimeout(timeoutFn);
    subMenu.classList.add("is-expanded");
  });
  
  header.addEventListener("mouseleave", function(event) {
    clearTimeout(timeoutFn);
    timeoutFn = setTimeout(() => subMenu.classList.remove("is-expanded"), 600);
  });
})();


// Built in Scrolling function
// add events to hash links
document.addEventListener("DOMContentLoaded", (event) => {
	var scrolllinks = document.querySelectorAll("a[href^='#']");
	console.log("scroll links")
  console.log(scrolllinks);
	for (var i = 0; i < scrolllinks.length; i++) {
		scrolllinks[i].addEventListener("click", scrolllinkclick);
	};
});

function scrolllinkclick(e) {
  e.preventDefault();
  console.log(e); 
  document.querySelector(e.target.hash).scrollIntoView({behavior: "smooth"});
}
